export default "__VITE_ASSET__cVPS1EFx__"